import { PureComponent } from 'react'

import {
  SecondaryColumnContentHorizontalRuler,
  ReadonlyBlock,
  ReadonlyLabel,
  ReadonlyField,
  ReadonlyFieldRow,
  ReadonlyFieldLabel,
} from '@/forms-legacy'
import * as OrderTexts from '../../../intl'

import { Props, FieldMode } from '../typings'
import * as Texts from '../intl'

export default class Priority extends PureComponent<Props> {
  render() {
    const { priority } = this.props

    const text: string = priority === FieldMode.mixed ? OrderTexts.getMixedText() : priority

    return (
      <>
        <ReadonlyBlock half>
          <ReadonlyLabel primary>{Texts.getImportanceText()}</ReadonlyLabel>

          <ReadonlyField>
            <ReadonlyFieldRow>
              <ReadonlyFieldLabel>{text}</ReadonlyFieldLabel>
            </ReadonlyFieldRow>
          </ReadonlyField>
        </ReadonlyBlock>
        <SecondaryColumnContentHorizontalRuler bottomSpace />
      </>
    )
  }
}
